import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import Translate from '../../../../../i18n/Translate';

const Footer = (props) => {
  const {
    onContinue, onBack, isLoading, continueDisabled, continueText,
  } = props;
  return (
    <div className="d-flex">
      {
        !!onBack && (
          <Button
            id="btn-back"
            className="m-0 p-3 mr-4 max-width-180 issuer-button-outline"
            color="outline-info"
            size="lg"
            block
            type="button"
            onClick={onBack}
          >
            <Translate translationKey="Texts.go-back" />
          </Button>
        )
      }
      <LaddaButton
        id="btn-continue"
        type="submit"
        color="primary"
        data-style={ZOOM_OUT}
        loading={isLoading}
        disabled={continueDisabled}
        className="btn p-3 m-0 text-white issuer-button-primary btn-block max-width-330 font-16 font-weight-bold"
        onClick={onContinue}
      >
        {continueText || <Translate translationKey="Texts.continue" />}
      </LaddaButton>
    </div>
  );
};

Footer.defaultProps = {
  onContinue: () => undefined,
  onBack: null,
  isLoading: false,
  continueText: '',
  continueDisabled: false,
};

Footer.propTypes = {
  onContinue: PropTypes.func,
  continueText: PropTypes.string,
  onBack: PropTypes.func,
  isLoading: PropTypes.bool,
  continueDisabled: PropTypes.bool,
};

export default Footer;
